module.exports = __webpack_public_path__ + "img/guide-student7.d374776d.png";